import React from 'react';
import { SpinnerBox } from './styles';
import AiLoadingIcon from '@/components/@IntranetLibrary/Spinner/AiLoading';

export type SpinnerProps = {
  readonly theme: 'white' | 'black' | 'ai';
  readonly size?: string;
  readonly className?: string;
};

const Spinner = ({ theme, size, className }: SpinnerProps) => {
  return (
    <>
      {theme === 'ai' ? (
        <AiLoadingIcon size={size} className={className} />
      ) : (
        <SpinnerBox
          className={className}
          background={theme === 'white' ? '#fff' : '#333'}
          width={size || '30px'}
        />
      )}
    </>
  );
};

export default Spinner;
